import { FolderNotFoundGitError } from '../errors/folder-not-found.git-error';
import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import { FSAction } from './actions.enum';

export interface FSRmDirAction extends WorkerAction {
  type: FSAction.RmDir;
  params: {
    path: string;
    skipSync?: boolean;
    cwd?: string;
    force?: boolean;
  };
}

class FSRmDirActionError extends WorkerActionError {}

export async function FSRmDirActionFn({ fs, params, util }: WorkerFnParams<FSRmDirAction>): Promise<void> {
  const { force, path, skipSync, cwd } = params;

  if (!force && !util.itemExistsAt(path)) {
    throw new FolderNotFoundGitError(path);
  }

  try {
    if (cwd) {
      fs.chdir(cwd);
    }

    deleteDirectoryRecursively(path);

    console.debug(`[WasmGit]: removing directory "${path}"`);
    try {
      fs.rmdir(path);
    } finally {
      if (!skipSync) {
        await util.syncfs(false);
      }
    }
  } catch (err) {
    throw new FSRmDirActionError(err);
  }

  function deleteDirectoryRecursively(pathToDir: string) {
    // Delete files and sub folders first
    const directory = fs
      .readdir(pathToDir)
      .filter((item) => !['.', '..'].includes(item))
      .map((item) => `${pathToDir}/${item}`);

    const files = directory.filter((item) => util.isFile(item));
    const dirs = directory.filter((item) => util.isDir(item));

    files.forEach((file) => {
      console.debug(`[WasmGit]: removing file "${file}"`);
      fs.unlink(file);
    });
    dirs.forEach((dir) => deleteDirectoryRecursively(dir));
    dirs.forEach((dir) => {
      console.debug(`[WasmGit]: removing directory "${dir}"`);
      fs.rmdir(dir);
    });
  }
}
